export default __webpack_public_path__ + "static/media/plusBlack.aeafd8ec.svg";